import script from "./PartnerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerPage.vue?vue&type=script&setup=true&lang=js"

import "./PartnerPage.vue?vue&type=style&index=0&id=095ca54c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095ca54c"]])

export default __exports__